import { SyntheticEvent } from 'react'

export const getAppIconFallback = (name: string) => {
  const initial = (name.trim().charAt(0) || '?').toUpperCase()
  const svg =
    '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 64 64\'>' +
    '<rect width=\'64\' height=\'64\' rx=\'14\' fill=\'#E5E7EB\'/>' +
    `<text x='32' y='42' font-family='sans-serif' font-size='28' font-weight='700' text-anchor='middle' fill='#6B7280'>${initial}</text>` +
    '</svg>'
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`
}

export const SCREENSHOT_FALLBACK_SRC = '/screenshot-fallback.svg'

export const handleImageFallback = (
  e: SyntheticEvent<HTMLImageElement>,
  fallbackSrc: string
) => {
  const img = e.currentTarget
  if (img.dataset.fallbackApplied === 'true') return
  img.dataset.fallbackApplied = 'true'
  img.src = fallbackSrc
}
